<!--
 * loading
 * 功能：显示消息loading
 * param  {Object}  loadingObj [loading框所需数据]
 * loadingObj = {
    isShow: '', // 是否展示
    tipsMsg: '', // 提示文案
  }
-->
<template>
  <div class="loading-box" v-show="isShow">
    <div class="loading-inner">
      <div class="icon"></div>
      <div class="intro">{{tipsMsg}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['loadingObj'],
  data() {
    return {
      isShow: false, // 是否显示弹框
      tipsMsg: "", // 提示文案
    };
  },
  methods: {
    // 关闭弹框的方法
    CloseNoticeTipsBoxFun: function () {
      this.isShow = false;
      this.$emit("update:loadingObj", null);
    },
    // 点击确定按钮
    ClickConfirmButtonFun: function () {
      // 执行回调函数
      if (this.callback && typeof this.callback === "function") {
        this.callback();
      }
      // 关闭弹框
      this.CloseNoticeTipsBoxFun();
    },
  },
  watch: {
    loadingObj: function () {
      const obj = this.loadingObj;
      if (Object.prototype.hasOwnProperty.call(obj, "isShow")) {
        this.isShow = obj.isShow;
        this.tipsMsg = obj.tipsMsg ? obj.tipsMsg : "加载中…";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
  .loading-inner {
    position: relative;
    top: 40%;
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 auto;
    padding-top: 0.6rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.2rem;
    overflow: hidden;
    .icon {
      width: 0.65rem;
      height: 0.65rem;
      margin: 0 auto;
      background: url(./img/loading.png) no-repeat center center;
      background-size: 100%;
      animation: loading 1s linear 0s infinite;
    }
    .intro {
      height: 0.44rem;
      margin-top: 0.34rem;
      font-size: 0.32rem;
      color: rgba(102, 102, 102, 1);
      line-height: 0.44rem;
      text-align: center;
    }
  }
}

@keyframes loading {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
</style>
